module.exports = __webpack_public_path__ + "img/NU.36462517.svg";